export default __webpack_public_path__ + "static/media/nobell-icon_dark.c63f3039.svg";